/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_LocationInputs */

const en_case_field_location = /** @type {(inputs: Case_Field_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const pt_br2_case_field_location = /** @type {(inputs: Case_Field_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Case_Field_LocationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_location = /** @type {((inputs?: Case_Field_LocationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_LocationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_location(inputs)
	return pt_br2_case_field_location(inputs)
});